// script.js
const popupOverlay = document.querySelector(".pop-up-content");
const popupContainer = document.querySelector(".pop-up-content");
const closePopupButton = document.getElementById("closemodal");

function openPopup() {
  popupOverlay.style.display = "flex";
  setTimeout(() => {
    popupContainer.style.opacity = "1";
    popupContainer.style.transform = "scale(1)";
  }, 100);
}

function closePopup() {
  popupContainer.style.opacity = "0";
  popupContainer.style.transform = "scale(0.8)";
  setTimeout(() => {
    popupOverlay.style.display = "none";
  }, 400);
}

// Automatically open the popup when the page loads
window.addEventListener("load", openPopup);

closePopupButton.addEventListener("click", closePopup);




